const styles = () => ({
  form: {
    padding: '0 0',
    flex: '1 0 auto',
    display: 'flex',
    flexDirection: 'column',
  },

  searchBuilderContainer: {
    flex: '1 0 auto',
    background: 'rgb(250, 251, 252)',
    borderTop: '1px solid rgba(89, 97, 104, 0.15)',
    padding: '40px 40px',
    margin: '0 0',
  },
});

export default styles;
